import { QbItaParameterResult } from '@fwmovilidad/qb-home-ita-components-lib';

export type ComboBoxStatus = {
  options: QbItaParameterResult[];
  selectedOption: QbItaParameterResult;
};
